document.addEventListener('DOMContentLoaded', function () {
  const tabTitles = document.querySelectorAll('.product-tabs__title');
  const tabContents = document.querySelectorAll('.product-tab-content');
  tabTitles.forEach(function (tab) {
    tab.addEventListener('click', function () {
      const selectedAttr = this.getAttribute('data-attr');
      tabTitles.forEach(function (el) {
        el.classList.remove('active');
      });
      this.classList.add('active');
      tabContents.forEach(function (content) {
        if (content.getAttribute('data-attr') === selectedAttr) {
          content.classList.remove('hidden');
        } else {
          content.classList.add('hidden');
        }
      });
    });
  });
});